// extracted by mini-css-extract-plugin
export default {"component-container":"auditSecurity_component-container__bzygO","component-caption":"auditSecurity_component-caption__2osjj"};